import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const Card = ({ label, value, to, testid, warn }) => (
  <Link to={to} className="card-soft p-5 lift block" data-testid={testid}>
    <p className={`font-display text-3xl font-bold ${warn && value ? "text-red-700" : "text-navy"}`}>{value ?? "—"}</p>
    <p className="text-xs uppercase tracking-[0.12em] text-muted-ink mt-2">{label}</p>
  </Link>
);

export const PipelineOverview = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/dashboard/pipeline").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  const ob = (s) => d.onboarding[s] || 0;
  const q = (k, v) => `/volunteers?${k}=${encodeURIComponent(v)}`;
  return (
    <section className="fade-up" data-testid="pipeline-overview">
      <p className="eyebrow">Planning Center & onboarding</p>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 mt-4">
        <Card label="Volunteers" value={d.volunteers} to="/volunteers" testid="pipe-volunteers" />
        <Card label="Completed assessments" value={d.assessments} to="/volunteers" testid="pipe-assessments" />
        <Card label="Synced to PCO" value={d.synced} to={q("sync", "synced")} testid="pipe-synced" />
        <Card label="Waiting to sync" value={d.waiting} to={q("sync", "waiting")} testid="pipe-waiting" />
        <Card label="Sync errors" value={d.errors} to={q("sync", "error")} testid="pipe-errors" warn />
        <Card label="Duplicates to review" value={d.review} to={q("sync", "review")} testid="pipe-review" warn />
        <Card label="Awaiting interview" value={ob("Interview Pending")} to={q("onboarding", "Interview Pending")} testid="pipe-interview" />
        <Card label="Awaiting training" value={ob("Training Pending")} to={q("onboarding", "Training Pending")} testid="pipe-training" />
        <Card label="Approved to serve" value={ob("Approved to Serve")} to={q("onboarding", "Approved to Serve")} testid="pipe-approved" />
        <Card label="Assigned to team" value={ob("Assigned to Team")} to={q("onboarding", "Assigned to Team")} testid="pipe-assigned" />
        <Card label="Active volunteers" value={ob("Active Volunteer")} to={q("onboarding", "Active Volunteer")} testid="pipe-active" />
        <Card label="Ministry approved" value={d.approved_ministry} to={q("approved", "any")} testid="pipe-ministry-approved" />
      </div>
    </section>
  );
};
